import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const ticketingDashboardStatKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'stats'] as const;
  return createQueryKey({
    all: [...key] as const,
  });
};

export { ticketingDashboardStatKeys };
